module.exports = __webpack_public_path__ + "68625d812cf748239ce5dc8dd4d09ae6.pdf";